module.exports = __webpack_public_path__ + "static/media/mas.0123fca3.svg";